// Load more news feed articles
const { $ } = window;

$(() => {
  $('.load-more-bar').on('click', function callback() {
    const $this = $(this);
    const $parent = $this.parent();

    if ($this.attr('data-cursor')) {
      $parent.addClass('loading');
      $this.find('h6').text('LOADING...');

      let fetchUrl = $this.attr('data-url');

      if ($this.attr('data-include-top-stories') === '') {
        fetchUrl += '/false';
      }

      fetchUrl += window.location.search;

      $.getJSON(
        fetchUrl,
        {
          count: $this.attr('data-count'),
          cursor: $this.attr('data-cursor'),
        },
        (data) => {
          $parent
            .parent()
            .find('.article-container')
            .append(data.html);
          window.feather.replace();
          $this.attr('data-cursor', data.cursor);
          $this.attr('data-count', parseInt($this.attr('data-count'), 10) + data.count);
        },
      ).done(() => {
        if ($this.attr('data-cursor')) {
          $parent.removeClass('loading');
          $this
            .find('h6')
            .text(`LOAD MORE ${$this.attr('data-item-type')}`);
        } else {
          $this
            .find('h6')
            .text(`NO MORE ${$this.attr('data-item-type')}`);
        }
      });
    }
  });
});
